export default {
    passwordChange: {
        oldPass: "Old password",
        newPass: "New password",
        change: "Change",
    }
};
